import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DashboardService } from './dashboard.service';

export interface DashboardQuoteSummary {
  quote_id: string;
  quote_type: number;
  quote_status: string;
  quote_ref: string;
  customer_id: string;
  customer_name: string;
  created_by: string;
  full_name: string;
  base_total: string | null;
  total_price: string | null;
  service_total: string | null;
  dtm_quote: string;
}

export const dashboardDataResolver: ResolveFn<DashboardQuoteSummary[]> = (
  route,
  state,
) => {
  const service = inject(DashboardService);

  return service.getSummary();
};
